import React from "react";
import {
  LocalShipping,
  AccessTime,
  VerifiedUser,
  Inventory,
  WorkspacePremium,
  Build,
} from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

interface AdditionalInfoProps {}

const AdditionalInfo: React.FC<AdditionalInfoProps> = (props) => {
  const items = [
    {
      icon: <Inventory className="text-sky-500" />,
      text: (
        <Typography>
          <span className="font-bold text-red-600">
            Hỗ trợ trả góp lãi suất thấp, quẹt thẻ tận nơi.
          </span>
        </Typography>
      ),
    },
    {
      icon: <AccessTime className="text-sky-500" />,
      text: (
        <Typography>
          Mở cửa từ <span className="font-bold">08 - 18h</span> cả T7, CN.
        </Typography>
      ),
    },
    {
      icon: <VerifiedUser className="text-sky-500" />,
      text: (
        <Typography>
          Bảo hành chính hãng, hệ thống trạm BH toàn quốc tận nhà quý khách:{" "}
          <span className="font-bold">2 năm thân máy, 5 năm máy nén.</span>{" "}
          <span className="text-sky-500 font-bold">XEM ĐIỂM BẢO HÀNH</span>
        </Typography>
      ),
    },
    {
      icon: <Inventory className="text-sky-500" />,
      text: (
        <Typography>
          Thùng máy lạnh nguyên đai - nguyên kiện theo tiêu chuẩn NSX
        </Typography>
      ),
    },
    {
      icon: <WorkspacePremium className="text-sky-500" />,
      text: (
        <Typography>
          Cam kết sản phẩm chính hãng{" "}
          <span className="text-sky-500">mới 100%</span>. Bồi thường{" "}
          <span className="font-bold">200%</span> nếu phát hiện máy không chính
          hãng.
        </Typography>
      ),
    },
    {
      icon: <LocalShipping className="text-sky-500" />,
      text: (
        <Typography>
          Miễn phí vận chuyển nội thành TP. HCM. <br />
          Hỗ trợ giao hàng{" "}
          <span className="font-bold">lắp đặt nhanh - ngoài giờ</span> theo yêu
          cầu. <br />
          <span className="text-sky-500 font-bold">
            Ưu đãi quý khách các tỉnh
          </span>{" "}
          Tiền Giang, Long An, Tây Ninh, Bình Dương, Vũng Tàu, Đồng Nai, Phan
          Thiết.
        </Typography>
      ),
    },
    {
      icon: <Build className="text-sky-500" />,
      text: (
        <Typography>
          Kỹ thuật đào tạo từ hãng, chỉ sử dụng ống đồng dày &gt;0.71mm, nhập
          chính hãng Malaysia, dây điện Cadivi, ...
        </Typography>
      ),
    },
    {
      icon: <Inventory className="text-sky-500" />,
      text: (
        <Typography>
          Hỗ trợ thiết kế bản vẽ kỹ thuật AutoCAD cho hệ thống lạnh KH.
        </Typography>
      ),
    },
    {
      icon: <Inventory className="text-sky-500" />,
      text: (
        <Typography>
          <span className="font-bold text-sky-500">
            UY TÍN TRÊN 20 NĂM TRONG NGÀNH ĐIỆN LẠNH.
          </span>
        </Typography>
      ),
    },
    {
      icon: <Inventory className="text-sky-500" />,
      text: (
        <Typography>
          <span className="font-bold text-sky-500">BẢNG GIÁ MÁY LẠNH</span> Tốt
          hơn cho công trình call: <span className="font-bold">0812129696</span>
        </Typography>
      ),
    },
  ];
  return (
    <Box className="bg-gray-50 p-4 rounded-md space-y-3 shadow-sm">
      {items.map((item, i) => (
        <Box key={i} className="flex items-start gap-2">
          <span className="">{item.icon}</span>
          <Box>{item.text}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default AdditionalInfo;
